module.exports = __webpack_public_path__ + "img/Trustpilot_brandmark_gr-blk_RGB.1c731130.svg";